enum SupportRequestType {
  All = 'All',
  OneTime = 'OneTime',
  Monthly = 'Monthly',
}

export default SupportRequestType;
